import React, { useRef, useState } from 'react';
import CompGridCompetitionApply from '@components/grid/comp-grid-competitionApply.js';
import CompFormCompetitionApply from '@components/form/comp-form-competitionApply.js';
import SearchForm from '@components/form/fragment/comp-fmt-search.js';
import ButtonForm from '@components/form/fragment/comp-fmt-button.js';
import {removeGrid} from '@assets/js/api/commonApi.js';

const CompetitionApplyMng = (props) => {
    /****************************
     * Define required variables
     *****************************/
    const childRef = useRef();
    const childGridRef = useRef();
    const [params, setParams] = useState({});
    const [selectedRows, setSelectedRows] = useState([]);

    /**************************
     * Define button functions
     ***************************/
    const onNew = () => {
        childRef.current.modalToggle({mode: 'I'});
    }
    const onModify = (params) => {
        childRef.current.modalToggle({mode: 'M', ...params});
    }
    const onRemove = () => {
        if (selectedRows.length === 0) { alert('1건이상 선택해주세요.'); return; }
        const idsArray = [...selectedRows.ids];
        if (idsArray.length === 0) {
            alert('삭제할 항목을 선택해주세요.');
            return;
        }

        const deleteParams = {
            deleteList: idsArray.map(rowId => {
                // ${row.comptnCd}-${row.mtmkgCd}-${row.armType}-${row.plyrNm}-${row.email}
                const [comptnCd, mtmkgCd, armType, plyrNm, email] = rowId.split('|');
                return {
                    comptnCd: comptnCd,
                    mtmkgCd: mtmkgCd,
                    armType: armType,
                    plyrNm: plyrNm,
                    email: email
                };
            })
        };

        //대회 토너먼트의 선수로 등록이 된 선수는 제외 후 삭제처리 진행.
        removeGrid('/sys/comptapplymng/remove/info', deleteParams, {
            msg: {
                confirm: '선택된 ' + idsArray.length + '개 항목을 삭제하시겠습니까?\n해당 대회 토너먼트의 선수로 등록된 선수는 삭제되지 않습니다.',
            }
        }).then(res => {
            if (res && res.success) {
                //clear selected rows grid.
                setSelectedRows(new Set());
                onGridSearch();
            }
        });
    }
    const onGridSearch = () => {
        childGridRef.current.onGridSearch(params);
    }
    const onValChange = (e) => {
        const { id, value } = e.target;
        // Update the state with the new value
        setParams({ ...params, [id]: value });
    }

    /****************************
     * Define form config
     *****************************/
    const formObj = {
        id : 'searchForm',
        params : {
            comptnNm : {
                id: 'comptnNm',
                label: '대회',
                maxLength : 100,
            },
            plyrNm : {
                id : 'plyrNm',
                label : '선수명',
                maxLength : 100,
                // newLine : true
            },
            email : {
                id : 'email',
                label : '이메일',
                maxLength : 100
            },
            phone : {
                id : 'phone',
                label : '전화번호',
                maxLength : 20
            },
        }
    }
    const buttonConfig = {
        leftButtons: [
            { id: 'new', label: 'New', className: 'btn-success', onClick: onNew },
            { id: 'remove', label: 'Remove', className: 'btn-danger', onClick: onRemove }
        ],
        rightButtons: [
            { id: 'search', label: 'Search', className: 'btn-primary', onClick: onGridSearch }
        ]
    }

    return (
        <>
            {/* SearchForm */}
            <SearchForm formObj={formObj} onValChange={onValChange} onGridSearch={onGridSearch} params={params}/>

            {/* ButtonForm */}
            <ButtonForm buttonConfig={buttonConfig} />

            {/* Grid */}
            <CompGridCompetitionApply ref={childGridRef} onChildClick={onModify} onSelectionChange={setSelectedRows} />

            {/* Modal popup */}
            <CompFormCompetitionApply ref={childRef} onGridSearch={onGridSearch} />
        </>
    );
}

export default CompetitionApplyMng;